import {
  Button,
  Chip,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  Input,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";

// styles
import useStyles from "./styles";

import DateField from "components/CustomFields/DateField";
import DistributorsField from "components/CustomFields/DistributorsField";
import SelectField from "components/CustomFields/SelectField";
import ZonesField from "components/CustomFields/ZonesField";
import { format } from "date-fns";
import { getCurrentDate } from "utils/dateGetters.js";
import { dbGet } from "utils/DBFetchers";

import { WITH_WALLET_TYPE } from "pages/audit/tablesUtils/Sales";

const getDateFormatted = (date) => {
  return format(date, "yyyy/MM");
};

const status = {
  todos: 0,
  validos: 1,
  invalidos: 2,
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MIN_IMPORT_ID_LEN = 13;

const GES_PROGRAM_ID = 3;
const GES_SALE_AUDIT_DOCUMENTATION =
  "https://cfr-config.s3.sa-east-1.amazonaws.com/cfr_rules_documentation/ges_sale_audit_documentation.pdf";

const MiSalcobrand_PROGRAM_ID = 4;
const MiSalcobrand_SALE_AUDIT_DOCUMENTATION =
  "https://cfr-config.s3.sa-east-1.amazonaws.com/cfr_rules_documentation/MiSalcobrand_sale_audit_documentation.pdf";
  
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const errorsMap = {
  // SALES
  "Descuento porcentual informado cero": 1,
  "Presentación inexistente": 2,
  "Unidades totales informadas excedidas": 3,
  "Unidades totales informadas inválidas": 4,
  "Descuento informado cero": 5,
  "Vademécum inexistente para presentación": 14,
  "Precio GES inexistente para presentación": 15,
  "Descuento Mi Salco inexistente para presentación": 16,
  "Paciente inexistente": 18,
  "Empadronamiento inexistente para paciente": 19,
  "Distribuidor incorrecto para la fecha": 22,
  "Farmacia inexistente.": 23,
  "Fecha de venta invalida": 24,
  //"Empadronamiento expirado": 20,
  "Empadronamiento expirado": 21,
  // INSCRIPTIONS
  "Vademecum inexistente": 3,
  "Código de barras inexistente": 4,
  "Presentacion inexistente": 5,
  "Paciente ya tiene el producto": 7,
  "Fecha de empadronamiento invalida": 8,
  "Farmacia inexistente": 9,
  "Descuento erróneo": 10,
  "Paciente inexistente error": 11,
};

export default function SelectionForm({
  filters,
  setFilters,
  setIsLoading = null,
  hideTypeSelector = false,
  ...props
}) {
  var classes = useStyles();
  const [selectedProgram, setSelectedProgram] = useState("");
  const [selectedDistributor, setSelectedDistributor] = useState("");
  const [selectedZone, setSelectedZone] = useState("");
  const [allZones, setAllZones] = useState(["zona A", "zona B"]);
  const [observationsName, setObservationsName] = React.useState([]);
  const [invalids, setInvalids] = React.useState(false);
  const [openImportIDDialog, setOpenImportIDDialog] = useState(false);
  const [possiblesImportsIDs, setPossiblesImportsIDs] = useState([]);
  const allTypes = [
    { name: "Total", id: "total" },
    { name: "Tradicionales", id: "traditionals" },
    { name: "Quemables", id: "burnable" },
  ];
  const errorsList = Array.isArray(props.errors) ? props.errors : [];

  const SelectImportID = () => {
    return (
      <Select
        value={filters.importID}
        onChange={handleImportIDChange}
        variant="outlined"
        margin="dense"
        className={classes.generalSelectionField}
      >
        {possiblesImportsIDs.map((importID) => {
          return (
            <MenuItem
              key={importID.id ?? importID.label}
              value={importID.id ? importID.id : -1}
            >
              {importID.label}
            </MenuItem>
          );
        })}
      </Select>
    );
  };

  const handleImportIDChange = (event) => {
    setFilters({ ...filters, importID: event.target.value });
  };

  const handleClose = () => {
    setOpenImportIDDialog(false);
  };

  const handleDateChange = (date) => {
    setFilters({
      ...filters,
      period: date /*getDateFormatted(dateOnFirstDay)*/,
    });
  };

  const handleDistributorChange = (event) => {
    setSelectedDistributor(event.target.name);
    setFilters({
      ...filters,
      [event.target.name]: event.target.value,
    });
  };

  const handleZoneChange = (event) => {
    setSelectedZone(event.target.name);
    setFilters({
      ...filters,
      [event.target.name]: event.target.value,
    });
  };

  const handleProgramChange = (event) => {
    const programValue = Number(event.target.value);
    setSelectedProgram(programValue);
    setFilters({
      ...filters,
      [event.target.name]: programValue,
    });
  };

  const handleObservationChange = (event) => {
    const errorsId = event.target.value
      .map((value) => errorsMap[value])
      .filter((id) => typeof id === "number"); // descarta undefined

    setObservationsName(event.target.value);
    setFilters({
      ...filters,
      [event.target.name]: errorsId,
    });
  };

  const handleStatusChange = (event) => {
    const isInvalid = event.target.value === "invalidos";
    setInvalids(isInvalid);

    if (!isInvalid) {
      setObservationsName([]);
      // si querés limpiar el filtro en el objeto filters:
      setFilters({
        ...filters,
        [event.target.name]: status[event.target.value],
        observations: [],
      });
      return;
    }

    setFilters({ ...filters, [event.target.name]: status[event.target.value] });
  };

  const handleWithWalletTypeChange = (event) => {
    setFilters({ ...filters, with_wallet_type: event.target.value });
  };

  const handleTypeChange = (event) => {
    setFilters({ ...filters, [event.target.name]: event.target.value });
  };

  // Get zones (and in the future distributors too) from back
  useEffect(() => {
    getZones();
    setFilters({
      ...filters,
      period: getCurrentDate(),
    });
    // getDistributors();
  }, []);

  const parseImportIDAsDate = (importID) => {
    return new Date(
      +importID.slice(4, 8), // year
      +importID.slice(2, 4) - 1, // month
      +importID.slice(0, 2), // day
      +importID.slice(8, 10), // hour
      +importID.slice(10, 12), // minute
    );
  };

  useEffect(() => {
    setPossiblesImportsIDs([]);
    setOpenImportIDDialog(false);
    if (filters.distributor && filters.period && filters.program) {
      const periodFormated = format(filters.period, "yyyyMM");
      const period = `period=${periodFormated}`;
      const distributorId = `${filters.distributor ? `&distributor_id=${filters.distributor}` : ""
        }`;
      const programId = `&program_id=${filters.program}`;
      const auditType = props.sales ? "sales" : "inscriptions";
      setIsLoading && setIsLoading(true);
      dbGet(
        `audit/${auditType}/diff/import_id?${period}${distributorId}${programId}`,
      )
        .then((data) => {
          setIsLoading && setIsLoading(false);
          if (data.length > 1) {
            let sortedImports = data.sort((a, b) => {
              if (!a || a.toString().length < MIN_IMPORT_ID_LEN) return -1; // non existent ids and old import ids (shorter format) should go first
              if (!b || b.toString().length < MIN_IMPORT_ID_LEN) return 1; // non existent ids and old import ids (shorter format) should go first
              const aDate = parseImportIDAsDate(a.toString());
              const bDate = parseImportIDAsDate(b.toString());
              if (aDate > bDate) return 1;
              if (aDate < bDate) return -1;
              return 0;
            });

            sortedImports = sortedImports.map((importID, index) => {
              return { id: importID, label: `Importación ${index + 1}` };
            });

            setPossiblesImportsIDs(sortedImports);
            setOpenImportIDDialog(true);
          } else {
            // setFilters({ ...filters, importID: data.length ? data[0] : "" });
          }
        })
        .catch((err) => {
          setIsLoading && setIsLoading(false);
        });
    }
  }, [filters.distributor, filters.period, filters.program]);

  const getZones = () => {
    dbGet("zones")
      .then((data) => {
        if (data.length === 0) {
          return;
        }
        let zones = data.map((zone) => {
          return {
            name: zone.name,
            id: zone.id,
          };
        });
        zones.unshift({ name: "Todas", id: "0" });
        setAllZones(zones);
      })
      .catch((err) => { });
  };

  return (
    <>
      <Grid
        item
        xs={12}
        lg={12}
        style={{ marginBottom: "65px", marginLeft: "2.5%" }}
      >
        <Typography variant="h4" className={classes.alignedText}>
          Selección
        </Typography>
        <Divider />
      </Grid>

      <Grid item xs={5} className={classes.alignRight}>
        <Typography className={classes.alignedText} weight="bold">
          Período *
        </Typography>
      </Grid>
      <Grid item xs={7} className={classes.alignLeft}>
        <DateField
          views={["year", "month"]}
          minDate={new Date("2013-10-01")}
          maxDate={getCurrentDate()}
          format={"MM/yyyy"}
          value={filters.period || getCurrentDate()}
          onChange={handleDateChange}
          fieldClassName={classes.dateSelectionField}
        />
      </Grid>

      <Grid item xs={5} className={classes.alignRight}>
        <Typography className={classes.alignedText} weight="bold">
          Programa *
        </Typography>
      </Grid>
      <Grid item xs={7} className={classes.alignLeft}>
        <SelectField
          fieldClassName={classes.generalSelectionField}
          id="programs"
          label="Seleccione"
          name="program"
          value={filters.program ?? ""}
          onChange={handleProgramChange}
          allValues={props.programs ? props.programs : []}
        />
      </Grid>

      <Grid item xs={5} className={classes.alignRight}>
        <Typography className={classes.alignedText} weight="bold">
          Cadena *
        </Typography>
      </Grid>
      <Grid item xs={7} className={classes.alignLeft}>
        <DistributorsField
          fieldClassName={classes.generalSelectionField}
          value={selectedDistributor ? filters[selectedDistributor] : ""}
          program={selectedProgram}
          onChange={handleDistributorChange}
          independents={props.independents}
          excludePharmacies={true}
        />
      </Grid>

      <Grid item xs={5} className={classes.alignRight}>
        <Typography className={classes.alignedText} weight="bold">
          Zona
        </Typography>
      </Grid>
      <Grid item xs={7} className={classes.alignLeft}>
        <ZonesField
          fieldClassName={classes.generalSelectionField}
          value={selectedZone ? filters[selectedZone] : ""}
          onChange={handleZoneChange}
          allValues={allZones}
        />
      </Grid>

      {!hideTypeSelector && selectedProgram === 1 && (
        <>
          <Grid item xs={5} className={classes.alignRight}>
            <Typography className={classes.alignedText} weight="bold">
              Tipo
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.alignLeft}>
            <SelectField
              id="type"
              label="Seleccione"
              name="type"
              fieldClassName={classes.generalSelectionField}
              value={filters.type ?? "total"}
              onChange={handleTypeChange}
              allValues={allTypes}
            />
          </Grid>
        </>
      )}

      {possiblesImportsIDs.length > 0 && (
        <>
          <Grid item xs={5} className={classes.alignRight}>
            <Typography className={classes.alignedText} weight="bold">
              Fecha de importación
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.alignLeft}>
            <SelectImportID />
          </Grid>
        </>
      )}

      {selectedProgram === 1 && (
        <>
          <Grid item xs={5} className={classes.alignRight}>
            <Typography className={classes.alignedText} weight="bold">
              Billetera *
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.alignLeft}>
            <RadioGroup
              row
              aria-label="position"
              name="with_wallet_type"
              defaultValue={WITH_WALLET_TYPE.WITHOUT_WALLET}
              className={classes.rowValueItems}
              onChange={handleWithWalletTypeChange}
            >
              <FormControlLabel
                value={WITH_WALLET_TYPE.ALL}
                control={<Radio color="primary" />}
                label="Todas"
              />
              <FormControlLabel
                value={WITH_WALLET_TYPE.WITH_WALLET}
                control={<Radio color="primary" />}
                label="Con billetera"
              />
              <FormControlLabel
                value={WITH_WALLET_TYPE.WITHOUT_WALLET}
                control={<Radio color="primary" />}
                label="Sin billetera"
              />
            </RadioGroup>
          </Grid>
        </>
      )}

      <Grid item xs={5} className={classes.alignRight}>
        <Typography className={classes.alignedText} weight="bold">
          Estado *
        </Typography>
      </Grid>
      <Grid item xs={7} className={classes.alignLeft}>
        <RadioGroup
          row
          aria-label="position"
          name="status"
          defaultValue="todos"
          className={classes.rowValueItems}
          onChange={handleStatusChange}
        >
          <FormControlLabel
            value="todos"
            control={<Radio color="primary" />}
            label="Todos"
          />
          <FormControlLabel
            value="validos"
            control={<Radio color="primary" />}
            label="Válidos"
          />
          <FormControlLabel
            value="invalidos"
            control={<Radio color="primary" />}
            label="Inválidos"
          />
        </RadioGroup>
      </Grid>
{/* 
      {invalids ? (
        <>
          <Grid
            item
            xs={5}
            className={classes.alignRight}
            style={{ marginTop: "10px" }}
          >
            <Typography className={classes.alignedText} weight="bold">
              Errores
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.alignLeft}>
            <Select
              id="observations"
              name="observations"
              className={classes.errorSelectionField}
              multiple
              value={observationsName}
              onChange={handleObservationChange}
              input={<Input id="select-multiple-chip" />}
              renderValue={(selected) => (
                <div>
                  {selected.map((value) => {
                    return (
                      <Chip
                        key={value}
                        label={value}
                        className={classes.chip}
                      />
                    );
                  })}
                </div>
              )}
              MenuProps={MenuProps}
            >
              {errorsList.map((observation) => {
                return (
                  <MenuItem key={observation.id} value={observation.name}>
                    {observation.name}
                  </MenuItem>
                );
              })}
            </Select>
          </Grid>
        </>
      ) : (
        <></>
      )} */}

      <Grid
        item
        xs={12}
        style={{ marginTop: "20px" }}
        className={classes.uploadButton}
      >
        <div className={classes.buttonSpacing}>
          <Button
            variant="contained"
            color="primary"
            onClick={props.applyFunction}
            disabled={props.isLoading || props.isLoadingButton}
          >
            Aplicar
          </Button>
          {selectedProgram === GES_PROGRAM_ID && (
            <Button
              component="a"
              href={GES_SALE_AUDIT_DOCUMENTATION}
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
              variant="text"
              style={{ marginLeft: "12px" }}
            >
              Ver Documentación
            </Button>
          )}
          {selectedProgram === MiSalcobrand_PROGRAM_ID && (
            <Button
              component="a"
              href={MiSalcobrand_SALE_AUDIT_DOCUMENTATION}
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
              variant="text"
              style={{ marginLeft: "12px" }}
            >
              Ver Documentación
            </Button>
          )}
          {props.isLoadingButton && <CircularProgress />}
        </div>
      </Grid>
    </>
  );
}
